import { gql, useQuery } from "@apollo/client";
import { HomeOwnerUser } from "../../__generated__/types";

const GET_ALL_HOMEOWNERS_QUERY = gql`
  query GetAllHomeOwners {
    getAllHomeOwners {
      _id
      firstName
      lastName
      email
      zipCode
      subscription
      accountType
      emailVerified
      paymentStatus
      subscriptionDate
      billingInfo {
        firstName
        lastName
        address
        city
        state
        zipCode
        email
        phoneNumber
      }
    }
  }
`;

export const useGetAllHomeownersQuery = () => {
  const { data, loading, error, refetch } = useQuery<{
    getAllHomeOwners: HomeOwnerUser[];
  }>(GET_ALL_HOMEOWNERS_QUERY, {
    fetchPolicy: 'network-only', // Always fetch fresh data from the server
    errorPolicy: 'all', // Don't throw on GraphQL errors, return partial data
    notifyOnNetworkStatusChange: false, // Prevent unnecessary re-renders
  });

  return {
    homeowners: data?.getAllHomeOwners || [],
    loading,
    error,
    refetch,
  };
};
